<template>
    <b-overlay :show="loading" variant="white" :rounded="true">
        <template v-slot:overlay>
            <div class="text-center">
                <b-spinner
                    label="Carregando..."
                    style="width: 3rem; height: 3rem"
                />
            </div>
        </template>
        <b-card class="p-0 m-0 shadow-sm" body-class="p-2">
            <chart-unit
                left-axis-title="Fechamento (mm)"
                :datasets="datasets.closing"
            />
            <chart-unit
                left-axis-title="Deslizamento (mm)"
                :datasets="datasets.sliding"
            />
            <chart-unit
                left-axis-title="Recalque diferencial (mm)"
                :datasets="datasets.settlement_diff"
            />
        </b-card>
    </b-overlay>
</template>

<script>
import ChartUnit from "./components/ChartUnit";

export default {
    name: "TriaxialJointChart",
    components: {
        ChartUnit
    },
    props: {
        loading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            datasets: {
                closing: [],
                sliding: [],
                settlement_diff: []
            }
        };
    },
    methods: {
        async update({
            params,
            triaxialJointsReadings,
            triaxialJointsResults,
            concreteTemperatureReadings
        }) {
            const {
                concreteTemperatureThermometers,
                triaxialJoints,
                interestedData
            } = params;
            const readings = triaxialJointsReadings.filter(
                reading => !!triaxialJoints.find(item => item.id === reading.id)
            );
            const results = triaxialJointsResults.filter(
                result => !!triaxialJoints.find(item => item.id === result.id)
            );
            const temperatures = concreteTemperatureReadings.filter(
                reading =>
                    !!concreteTemperatureThermometers.find(
                        item => item.id === reading.id
                    )
            );

            const infos = [
                {
                    label: "Fechamento",
                    key: "closing"
                },
                {
                    label: "Deslizamento",
                    key: "sliding"
                },
                {
                    label: "Recalque diferencial",
                    key: "settlement_diff"
                }
            ];
            const datasets = {
                closing: [],
                sliding: [],
                settlement_diff: []
            };

            if (interestedData.includes("measure")) {
                for (const info of infos) {
                    for (const reading of readings) {
                        datasets[info.key].push({
                            label: `${reading.name} (medição)`,
                            yAxisID: "left-axis",
                            fill: false,
                            pointRadius: 0,
                            lineTension: 0,
                            data: reading.readings.map(result => ({
                                x: result.epoch,
                                y: result[info.key]
                            }))
                        });
                    }
                }
            }

            if (interestedData.includes("simulation")) {
                for (const info of infos) {
                    for (const result of results) {
                        datasets[info.key].push({
                            label: `${result.name} (simulação)`,
                            yAxisID: "left-axis",
                            fill: false,
                            pointRadius: 0,
                            lineTension: 0,
                            data: result.results.map(result => ({
                                x: result.epoch,
                                y: result[info.key]
                            }))
                        });
                    }
                }
            }

            for (const info of infos) {
                for (const temperature of temperatures) {
                    datasets[info.key].push({
                        label: temperature.name,
                        yAxisID: "right-axis",
                        fill: false,
                        pointRadius: 0,
                        lineTension: 0,
                        data: temperature.readings.map(result => ({
                            x: result.epoch,
                            y: result.value
                        }))
                    });
                }
            }

            this.datasets = datasets;

            await this.$nextTick();
        }
    }
};
</script>
